import { useEffect } from 'react'
import { createSlice } from '@reduxjs/toolkit'
import { useSelector, useDispatch } from 'react-redux'
import { createSelector } from 'reselect'
import { cleanReducerOnPageChange } from '../utils'
import isEmpty from "lodash/isEmpty"

export const VIEWPORT_TYPE = {
  MOBILE: 'MOBILE',
  TABLET: 'TABLET',
  DESKTOP: 'DESKTOP',
  LARGE_MONITOR: 'LARGE_MONITOR'
};

export const MOBILE_BREAKPOINT = 900;
export const TABLET_BREAKPOINT = 1100;
export const DESKTOP_BREAKPOINT = 1300;

export const getViewportType = () => {
    const width = window.innerWidth;
    if (width <= MOBILE_BREAKPOINT){
        return VIEWPORT_TYPE.MOBILE;
    } else if (width > MOBILE_BREAKPOINT && width <= TABLET_BREAKPOINT){
        return VIEWPORT_TYPE.TABLET;
    } else if (width > TABLET_BREAKPOINT && width <= DESKTOP_BREAKPOINT){
       return VIEWPORT_TYPE.DESKTOP;
    } else {
       return VIEWPORT_TYPE.LARGE_MONITOR;
    }
}

export const getInitialState = (state) => {
  state = state || {};
  state.viewport = getViewportType();
  state.messages = []
  state.infoPanel = {}
  state.exportPanel = false;
  state.splashscreen = false
  state.pagination = {}
  return state;
}


const initialState = getInitialState()

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setViewportType(state, action){
      state.viewport = action.payload;
    }
    ,showSplashScreen(state, action){
      state.splashscreen = action.payload;
    }
    ,showSidebar(state, action){
      state.sidebar = action.payload;
    }
    ,showExportPanel(state, action){
      state.exportPanel = action.payload;
    }
    ,showMapPanel(state, action){
      state.mapPanel = action.payload;
    }
    ,setInfoPanel(state, action){
      state.infoPanel = action.payload;
    }
    ,setPaginationPage(state, action){
      if (!action.payload.page){
        delete state.pagination[action.payload.prefix]
      } else {
        state.pagination[action.payload.prefix] = action.payload.page
      }
    }
    ,addMessage(state, action){
      const values = {
        message: "empty message!",
        status: '',
        timeout: null
      }

      if ((typeof action.payload) === 'object'){
        Object.assign(values, action.payload) 
      } else {
        values.message = action.payload
      }

      const {message, status, timeout} = values

      if (state.messages.map(x=>x.message).indexOf(message) !== -1) return

      const messagesId = state.messages.map(x=>x.id)
                                       .reduce(function(a, b) {
                                         return Math.max(a, b);
                                       }, 0)
      state.messages.push({
        id: messagesId + 1,
        message: message,
        status: status,
        timeout: timeout
      })

    }
    ,removeMessage(state, action){
      const idx = state.messages.find(x=> x.id === action.payload)
      if (idx){
        state.messages.splice(idx, 1)
      }
    }
  },
  extraReducers: (builder) => cleanReducerOnPageChange(builder, getInitialState)
})

export const isMobileViewport = (viewport) => viewport === VIEWPORT_TYPE.MOBILE || viewport === VIEWPORT_TYPE.TABLET 

export const 
  useIsMobile = () => useSelector(state => isMobileViewport(state.ui.viewport)),
  useSidebar = () => useSelector(state => state.ui.sidebar),
  useMapPanel = () => useSelector(state => state.ui.mapPanel),
  useExportPanel = () => useSelector(state => state.ui.exportPanel === true),
  useHaveMapPanel = () => useSelector(state => isMobileViewport(state.ui.viewport) && state.ui.mapPanel),
  useViewport = () => useSelector(state => state.ui.viewport),
  useSplashScreen = () => useSelector(state => state.ui.splashscreen),
  useMessages = () => useSelector(state => state.ui.messages),
  useScrollIsLock = () => useSelector(state => state.ui.sidebar != null || state.ui.exportPanel == true || (isMobileViewport(state.ui.viewport) && state.ui.mapPanel)),
  useInfoPanel = () => useSelector(state => state.ui.infoPanel),
  useHaveInfoPanel = () => useSelector(state => !isEmpty(state.ui.infoPanel)),
  usePagination = (prefix) => {
    const currentPage = parseInt(useSelector(state => (state.ui.pagination && state.ui.pagination[prefix]) ? state.ui.pagination[prefix] : 1))
    const isFirst = currentPage == 1
    const action = (page) => uiSlice.actions.setPaginationPage({prefix: prefix, page:page})
    const dispach = useDispatch()
    useEffect(()=>{
        return () => {
            if (isFirst) return
            dispach(action(null))
        }
    
    }, [isFirst, dispach])
    return [currentPage, action]
  }

export const { 
  logError, 
  setViewportType, 
  setInfoPanel,
  showSplashScreen, 
  showSidebar, 
  showMapPanel,  
  showExportPanel,
  addMessage,
  removeMessage
} = uiSlice.actions

export default uiSlice
